import styled from 'styled-components';

import { FieldWrapperStyled } from '../FormikInput/FormikInput.styled';

type InputPropsT = {
  isError: boolean;
};

export const InputWrapperStyled = styled(FieldWrapperStyled)<InputPropsT>`
  .react-tel-input {
    height: 40px;
    width: 100%;

    .form-control {
      height: 100%;
      width: 100%;
      border: 1px solid rgb(208, 208, 208);
      border-radius: 3px;

      ${({ theme, isError }) => `
        &:active,
        &:focus {
          border-color: ${theme.primaryColour};
        }

        ${isError ? 'border-color: #ff0000' : ''};

        &:disabled {
          border-color: #d0d0d0;
        }
     `}
    }

    .flag-dropdown {
      border: none;
      top: 1px;
      bottom: 1px;
      left: 1px;
    }
  }
`;
